<div class="access-denied-container">
    <h2>Access Denied</h2>
    
    <p>Contact LegitScript support to access this application.</p>
</div>
